import { render, staticRenderFns } from "./PendingRequests.vue?vue&type=template&id=5f57d30b&"
import script from "./PendingRequests.vue?vue&type=script&lang=js&"
export * from "./PendingRequests.vue?vue&type=script&lang=js&"
import style0 from "./PendingRequests.vue?vue&type=style&index=0&id=5f57d30b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports